module.exports = __webpack_public_path__ + "assets/img/40.5bf18dbf.svg";